export const {
  toggle,
  toggle: { get },
} = window.o_util;
